// 分销规则中，新建/修改规则里已选商品与已选分销商都在这管理
// 支持分页，查询等

const dr_selectedProds = {
  state: () => ({
    list: [], // 所选的商品列表
    type: 'spu', // 当前列表类型 spu | sku
    distributorList: [], // 所选分销商列表
  }),
  mutations: {
    setList(state, list) {
      state.list = list
    },
    setType(state, type) {
      state.type = type
    },
    setDistributorList(state, list) {
        state.distributorList = list
    }
  },
  actions: {
    // 初始化数据（覆盖）
    dr_selectedInit({commit}, newItems) {
        let newList = [...newItems];
        commit('setList', newList)
    },
      // 追加数据
    dr_selectedAdd({commit, state}, newItems) {
        let newList = [...state.list]
        let type = state.type
        let key = type === 'spu' ? 'outerId' : 'skuOuterId'
        newItems.forEach(element => {
            if (newList.find(i => i[key] === element[key])) {
                // 去重
                return;
            }
            newList.unshift(element);
        });
        commit('setList', newList);
    },
    // 清空数据
    dr_selectedClear({commit}) {
        commit('setList', [])
    },
    // 移除数据
    dr_selectedRemove({commit, state}, removeItems) {
        let newList = []
        let type = state.type
        let key = type === 'spu' ? 'outerId' : 'skuOuterId'
        let removeValues = removeItems.map(item => item[key])
        state.list.forEach(element => {
            if (removeValues.includes(element[key])) {
                return;
            }
            newList.push(element)
        });
        commit('setList', newList)
    },
    // 改变当前类型
    dr_changeType({commit}, type) {
        commit('setType', type)
    },
    /**** 分销商 ****/
    // drd_ 开头区分商品列表
    drd_selectedInit({commit}, newItems) {
        let newList = [...newItems];
        commit('setDistributorList', newList)
    },
    drd_selectedClear({commit}) {
        commit('setDistributorList', [])
    },
    drd_selectedRemove({commit, state}, removeItems) {
        let newList = []
        let key = 'id'
        let removeValues = removeItems.map(item => item[key])
        state.distributorList.forEach(element => {
            if (removeValues.includes(element[key])) {
                return;
            }
            newList.push(element)
        });
        commit('setDistributorList', newList)
    },
  },
  getters: {
    // 基础查询
    // 第一参数是查询参数相关，第二个参数是查询哪个列表，默认查询 list 商品 可以传 distributorList 查询分销商
    // 不直接对外使用，封装一层，用于单独查询商品或者分销商
    inway_dr_query(state) {
        const exactFields = ['distributorLevel'] // 需要精确搜索的字段
        const commaFields = ['skuOuterIds', 'outerIds'] // 逗号拼接的字段
        return ({pageSize = 10, pageNo = 1, ...queryParams } = {}, listKey = 'list') => {
            console.log(queryParams)
            let allList = state[listKey].filter(item => {
                if (!queryParams) {
                    return true
                }
                let passMap = {};
                for (const query in queryParams) {
                    passMap[query] = true
                    if (!queryParams[query]) {
                        continue
                    }
                    // 处理逗号拼接的查询
                    if (commaFields.includes(query)) {
                        let subPass = false
                        let itemKey = query.slice(0, query.length - 1) // 逗号拼接的需要去掉最后的s才是数据中的需要查询的key

                        let queryArr = queryParams[query].split(',').filter(Boolean);
                        if (queryArr.length > 1) {
                            // 有多个的话需要精确匹配
                            queryArr.forEach(outerId => {
                                if (outerId === item[itemKey]) {
                                    subPass = true
                                }
                            })
                        } else {
                            // 一个的话就只要模糊匹配
                            if (item[itemKey].indexOf(queryArr[0]) > -1) {
                                subPass = true
                            }
                        }


                        passMap[query] = subPass
                    } else if (exactFields.includes(query)) {
                        console.log(item[query], queryParams[query])
                        // 处理精准匹配
                        passMap[query] = String(item[query]) === String(queryParams[query])
                    } else if (!new RegExp(queryParams[query]).test(item[query])) {
                        passMap[query] = false
                    }
                }

                return Object.values(passMap).every(Boolean);
            });
            const startIndex = (pageNo - 1) * pageSize
            const endIndex = startIndex + pageSize
            return {
                list: allList.slice(startIndex, endIndex),
                total: allList.length
            } 
        }
    },
    // 查询商品
    dr_query(state, getters) {
        return (queryParams = {}) => {
            return getters.inway_dr_query(queryParams, 'list')
        }
    },
    // 查询分销商
    drd_query(state, getters) {
        return (queryParams = {}) => {
            return getters.inway_dr_query(queryParams, 'distributorList')
        }
    },
    // 当前商品的编码 spu 取 outerId | sku 取 skuOuterId
    dr_getAllOuterId(state) {
        const outerIdKey = state.type === 'sku' ? 'skuOuterId' : 'outerId'
        return state.list.map(item => {
            return item[outerIdKey]
        }).join(',')
    },
    // 获取当前所选商品列表
    dr_allSelected(state) {
        return state.list
    },
    // 获取当前所选分销商列表
    drd_allSelected(state) {
        return state.distributorList
    }
  }
}

export default dr_selectedProds

